import React from "react";

export interface Options {
    value: string;
    label: React.ReactNode;
    key?: number;
    disabled?: boolean;
    selected?: boolean;
}

export interface SelectProps
    extends React.DetailedHTMLProps<React.SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement> {
    options: Array<Options>;
    placeholder?: string;
    name: string;
}

const Select: React.FC<SelectProps> = ({ placeholder, options, className = "field-control__input", ...props }) => {
    return (
        <select className={className} {...props}>
            {placeholder && <option value={""}>{placeholder}</option>}
            {options.map((option) => (
                <option key={option.key ?? option.value} value={option.value} disabled={option.disabled}>
                    {option.label}
                </option>
            ))}
        </select>
    );
};

export default Select;
